import React from "react";
import { Pagination } from "react-bootstrap";

export class CustomPagination extends React.Component {

    render() {
        const { firstPage, lastPage, totalPages, currentPage, onPageChange } = this.props;
        let pagesList = [];

        for (let i = firstPage; i <= lastPage; i++) {
            let isActive = i === currentPage;

            let pageEle = (
                <li className="page-item">
                    <a
                        href="#"
                        className={`page-link ${isActive ? "background-green text-white" : "text-green"}`}
                        onClick={(e) => onPageChange(i)}>{i}</a>
                </li>);

            pagesList.push(pageEle);
        }

        return (
            <Pagination className='col-auto'>
                <Pagination.First id={"to-first-page-btn"} onClick={() => onPageChange(1)} />
                {pagesList}
                <Pagination.Last id={"to-last-page-btn"} onClick={() => onPageChange(totalPages)} />
            </Pagination>
        )
    }
}